module.exports = __webpack_public_path__ + "static/media/magic_icon.6729c7c0.svg";